export enum RouteName {
  ROOT = 'ROOT',
  HOME = 'HOME',
  MAP = 'MAP',
  PARKING_SEARCH_RESULTS = 'PARKING_SEARCH_RESULTS',
  PARKING_DETAILS = 'PARKING_DETAILS',
  DEV_FEATURE_FLAGS = 'DEV_FEATURE_FLAGS',
  FILES_DOWNLOAD = 'FILES_DOWNLOAD',
  DEV_SPLASH_SCREEN = 'DEV_SPLASH_SCREEN',
  RESERVATION_FLOW = 'RESERVATION_FLOW',
  RESERVATION_QR = 'RESERVATION_QR',
  RESERVATION_DURATION = 'RESERVATION_DURATION',
  RESERVATION_SUCCESS = 'RESERVATION_SUCCESS',
  RESERVATION_FAILURE = 'RESERVATION_FAILURE',
  RESERVATION_PAYMENT = 'RESERVATION_PAYMENT',
  RESERVATION_PAYMENT_STATUS_SUCCESS = 'RESERVATION_PAYMENT_STATUS_SUCCESS',
  RESERVATION_PAYMENT_STATUS_FAILURE = 'RESERVATION_PAYMENT_STATUS_FAILURE',
  RESERVATION_SPAN_PAYMENT_LINK = 'RESERVATION_SPAN_PAYMENT_LINK',
  RESERVATION_SPAN_PAYMENT_LINK_SUCCESS = 'RESERVATION_SPAN_PAYMENT_LINK_SUCCESS',
  RESERVATION_SPAN_PAYMENT_LINK_FAILURE = 'RESERVATION_SPAN_PAYMENT_LINK_FAILURE',
  PARKING_LANDING = 'PARKING_LANDING',
  PARKING_LANDING_WITH_SPOT = 'PARKING_LANDING_WITH_SPOT',
  MY_PARKINGS = 'MY_PARKINGS',
  MY_SPOTS = 'MY_SPOTS',
  MY_PARKING_CREATE = 'MY_PARKING_CREATE',
  MY_PARKING_CREATE_OWN = 'MY_PARKING_CREATE_OWN',
  MY_PARKING_CREATE_ENTRANCE_LOCATION = 'MY_PARKING_CREATE_ENTRANCE_LOCATION',
  MY_PARKING_CREATE_LOT_MODE = 'MY_PARKING_CREATE_LOT_MODE',
  MY_PARKING_CREATE_SPOTS = 'MY_PARKING_CREATE_SPOTS',
  MY_PARKING_MANAGE = 'MY_PARKING_MANAGE',
  MY_PARKING_MANAGE_BILLING_EDIT = 'MY_PARKING_MANAGE_BILLING_EDIT',
  MY_PARKING_MANAGE_BILLING_SELECTION = 'MY_PARKING_MANAGE_BILLING_SELECTION',
  MY_PARKING_MANAGE_DIMENSIONS = 'MY_PARKING_MANAGE_DIMENSIONS',
  MY_PARKING_MANAGE_GALLERY = 'MY_PARKING_MANAGE_GALLERY',
  MY_PARKING_MANAGE_LOCATION = 'MY_PARKING_MANAGE_LOCATION',
  MY_PARKING_MANAGE_PRICE_RULES = 'MY_PARKING_MANAGE_PRICE_RULES',
  MY_PARKING_MANAGE_PRICE_RULES_CREATE = 'MY_PARKING_MANAGE_PRICE_RULES_CREATE',
  MY_PARKING_MANAGE_PRICE_RULES_EDIT = 'MY_PARKING_MANAGE_PRICE_RULES_EDIT',
  MY_PARKING_MANAGE_SETTINGS = 'MY_PARKING_MANAGE_SETTINGS',
  MY_PARKING_MANAGE_SIGNAGE = 'MY_PARKING_MANAGE_SIGNAGE',
  MY_PARKING_MANAGE_SPOTS = 'MY_PARKING_MANAGE_SPOTS',
  MY_PARKING_MANAGE_SPOTS_CREATE = 'MY_PARKING_MANAGE_SPOTS_CREATE',
  MY_PARKING_MANAGE_SPOTS_EDIT = 'MY_PARKING_MANAGE_SPOTS_EDIT',
  MY_PARKING_MANAGE_UNAVAILABILITIES = 'MY_PARKING_MANAGE_UNAVAILABILITIES',
  MY_PARKING_MANAGE_UNAVAILABILITY_CREATE = 'MY_PARKING_MANAGE_UNAVAILABILITY_CREATE',
  MY_PARKING_MANAGE_UNAVAILABILITY_EDIT = 'MY_PARKING_MANAGE_UNAVAILABILITY_EDIT',
  MY_PARKING_MANAGE_VEHICLES = 'MY_PARKING_MANAGE_VEHICLES',
  MY_PARKING_MANAGE_VEHICLES_CREATE = 'MY_PARKING_MANAGE_VEHICLES_CREATE',
  MY_PARKING_MANAGE_VEHICLES_EDIT = 'MY_PARKING_MANAGE_VEHICLES_EDIT',
  MY_PARKING_GATES = 'MY_PARKING_GATES',
  ACCOUNT = 'ACCOUNT',
  ACCOUNT_EDIT = 'ACCOUNT_EDIT',
  START_EARNING = 'START_EARNING',
  ACCOUNT_VEHICLES = 'ACCOUNT_VEHICLES',
  ACCOUNT_VEHICLE_DETAILS = 'ACCOUNT_VEHICLE_DETAILS',
  ACCOUNT_VEHICLE_CREATE = 'ACCOUNT_VEHICLE_CREATE',
  ACCOUNT_BILLINGS = 'ACCOUNT_BILLINGS',
  ACCOUNT_BILLING_CREATE = 'ACCOUNT_BILLING_CREATE',
  ACCOUNT_BILLING_EDIT = 'ACCOUNT_BILLING_EDIT',
  ACCOUNT_TICKETS = 'ACCOUNT_TICKETS',
  ACCOUNT_TICKET_CREATE = 'ACCOUNT_TICKET_CREATE',
  ACCOUNT_TICKET_CREATE_FROM_RESERVATION = 'ACCOUNT_TICKET_CREATE_FROM_RESERVATION',
  ACCOUNT_TICKET_SENT = 'ACCOUNT_TICKET_SENT',
  ACCOUNT_TICKET_DETAILS = 'ACCOUNT_TICKET_DETAILS',
  ACCOUNT_RESERVATIONS = 'ACCOUNT_RESERVATIONS',
  ACCOUNT_RESERVATIONS_PENDING = 'ACCOUNT_RESERVATIONS_PENDING',
  ACCOUNT_RESERVATION = 'ACCOUNT_RESERVATION',
  ACCOUNT_RESERVATION_SPOT_TAKEN = 'ACCOUNT_RESERVATION_SPOT_TAKEN',
  ACCOUNT_RESERVATIONS_HISTORY = 'ACCOUNT_RESERVATIONS_HISTORY',
  ACCOUNT_PAYMENT_HISTORY = 'ACCOUNT_PAYMENT_HISTORY',
  ACCOUNT_WALLET = 'ACCOUNT_WALLET',
  ACCOUNT_WALLET_TRANSACTIONS = 'ACCOUNT_WALLET_TRANSACTIONS',
  ACCOUNT_WALLET_TOP_UP = 'ACCOUNT_WALLET_TOP_UP',
  ACCOUNT_WALLET_TOP_UP_PAYMENT = 'ACCOUNT_WALLET_TOP_UP_PAYMENT',
  ACCOUNT_CONTACT = 'ACCOUNT_CONTACT',
  ACCOUNT_REGULATIONS = 'ACCOUNT_REGULATIONS',
  ACCOUNT_PARTNER = 'ACCOUNT_PARTNER',
  ACCOUNT_CONTROLLER = 'ACCOUNT_CONTROLLER',
  ACCOUNT_BECOME_CONTROLLER = 'ACCOUNT_BECOME_CONTROLLER',
  AUTH_PASSWORD_RESET = 'AUTH_PASSWORD_RESET',
  NOT_FOUND = 'NOT_FOUND',
}
